import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      name: 'landing',
      path: '/',
      component: () => import('../pages/LandingPage.vue'),
      meta: { requiresAuth: false }
    },
    {
      name: 'home',
      path: '/home',
      component: () => import('../pages/UserHomePage.vue'),
      meta: { requiresAuth: true }
    },
    {
      name: 'admin-dashboard',
      path: '/admin',
      component: () => import('../pages/AdminDashboardPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      name: 'admin-users',
      path: '/admin/users',
      component: () => import('../pages/AdminUsersPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      name: 'secretary-tasks',
      path: '/secretary/tasks/:status',
      component: () => import('../pages/SecretaryTasksPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      name: 'secretary-search-court-sessions',
      path: '/secretary/search-court-sessions',
      component: () => import('../pages/SecretarySearchCourtSessionsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      name: 'task',
      path: '/task/:taskType/:taskId/',
      component: () => import('../pages/TaskPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      name: 'transcription-tasks',
      path: '/transcription-tasks',
      component: () => import('../pages/TranscriptionTasksPage.vue'),
      meta: {
        requiresAuth: true
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  authStore.initializeUsingPrincipalCookie()
  switch (to.name) {
    case 'home':
    case 'tasks':
    case 'task':
    case 'court-sessions':
    case 'test-task':
      if (authStore.user.employeeType === 'Genikos Diaxeiristis') {
        console.log('Redirecting admin to admin-dashboard')
        return next({ name: 'admin-dashboard' })
      }
      break
    case 'admin-dashboard':
    case 'admin-users':
    case 'admin-tapclients':
    case 'admin-licenses':
      if (authStore.user.employeeType !== 'Genikos Diaxeiristis') {
        console.log('Non-admin user attempting to access admin page, redirecting to home')
        return next({ name: 'home' })
      }
      break
    case 'transcription-tasks':
      if (authStore.user.employeeType !== 'Apoixografitis') {
        console.log(
          'User with no permission attempting to access transcription-tasks, redirecting to home'
        )
        return next({ name: 'home' })
      }
      break
    default:
      break
  }
  if (authStore.isLoggedIn && authStore.user.employeeType === 'Genikos Diaxeiristis') {
    if (!to.path.startsWith('/admin')) {
      console.log('Redirecting admin to admin-dashboard')
      return next({ name: 'admin-dashboard' })
    }
  }
  next()
})

export default router
